export default __webpack_public_path__ + "static/media/mic-on-white.128e64d5.svg";